import styled from "styled-components";

interface SkeletonAnimatedButtonProps {
    width: string;
    height: string;
    borderRadius?: string;
}

export const SkeletonAnimatedButton = styled.div<SkeletonAnimatedButtonProps>`

    width: ${({width}) => width};
    height: ${({height}) => height};
    margin-left: auto;

    background: rgba(255, 255, 255, 0.25);

    border-radius: ${({borderRadius}) => borderRadius || "5px"};
    animation: PulsatingAnimation 2.5s alternate infinite;

    @keyframes PulsatingAnimation {
        0% {
            opacity: 1;
        }
        100% {
            opacity: 0.25;
        }
    }
`;
